import { CloseOutlined } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";

interface IFormHeaderProps {
  title: string;
  handleClose?: () => void;
  disabled?: boolean;
  additionalComponent?: React.ReactNode;
}

export const FormHeader = (props: IFormHeaderProps) => {
  const { title, disabled, handleClose, additionalComponent } = props;
  return (
    <Box
      sx={(theme) => ({
        height: theme.mixins.toolbar.minHeight,
        backgroundColor: theme.palette.grey[100],
      })}
    >
      <Stack
        spacing={2}
        direction="row"
        sx={{
          px: 3,
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: "fontWeightSemiBold",
            color: "primary.main",
          }}
        >
          {title}
        </Typography>
        {additionalComponent}
        {handleClose && (
          <IconButton
            disabled={disabled}
            onClick={handleClose}
            sx={{
              color: "primary.main",
            }}
          >
            <CloseOutlined />
          </IconButton>
        )}
      </Stack>
    </Box>
  );
};
